import { AxiosResponse } from "axios";
import { Snackbar } from "components/general/Snackbar";
import { isStoreDetailsIssueError } from "adminPanel/stores/isStoreDetailsIssueError";
import { isPrintDesignMissingMandatoryError } from "adminPanel/Print/isPrintDesignMissingMandatoryError";
import { isSessionDeactivatedError } from "./isSessionDeactivatedError";

export default function reportHttpErrors(
  response: AxiosResponse,
  snack: typeof Snackbar
) {
  if (!response) return;

  if (isSessionDeactivatedError(response)) return;
  if (isStoreDetailsIssueError(response)) return;
  if (isPrintDesignMissingMandatoryError(response)) return;
  function reloadPage() {
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }
  const errors = response?.data?.errors;
  function getFirstError(errors: any, depth = 1) {
    for (const key in errors) {
      if (Array.isArray(errors[key]) && errors[key].length > 0) {
        return errors[key][0];
      } else if (typeof errors[key] === "object" && depth > 1) {
        return getFirstError(errors[key], depth - 1);
      }
    }
    return;
  }
  // refact. later on to switch case with enum for error http status
  if (response?.status === 400) {
    snack(getFirstError(errors), "error");
  } else if (response?.status === 406) {
    snack(getFirstError(errors), "warning");
    reloadPage();
  } else if (response?.status === 401) {
    snack(getFirstError(errors), "error");
    reloadPage();
  } else if (response?.status === 403) {
    snack(getFirstError(errors), "error");
  } else if (response?.status === 409) {
  } else if (response?.status === 432) {
  } else if (response?.status === 433) {
    snack(getFirstError(errors), "warning");
  } else {
    snack("Service Connection Problem.", "error");
  }
}
